import ApiService from '../../../core/services/ApiService';

export interface M1DifferenceRow {
  id: string;
  categoryName: string;
  categoryType: string;
  bookAmount: number;
  taxAmount: number;
  cumulativeDifference: number;
}

export interface M1Summary {
  totalCumulativeBookAmount: number;
  totalCumulativeTaxAmount: number;
  netCumulativeDifference: number;
  categories: M1DifferenceRow[];
}

class M1Service extends ApiService {
  getM1Differences(partnershipId: string, taxYear: string): Promise<M1Summary> {
    return this.makeRequest<M1Summary>(
      `/api/m1-differences?partnershipId=${partnershipId}&taxYear=${taxYear}`,
      { extractData: true },
    );
  }

  createCategory(
    data: Partial<M1DifferenceRow> & { partnershipId: string; taxYear: string },
  ): Promise<M1DifferenceRow> {
    return this.makeRequest<M1DifferenceRow>(
      '/api/m1-differences',
      { method: 'post', data: data as unknown as Record<string, unknown>, extractData: true },
    );
  }

  updateCategory(id: string, data: Partial<M1DifferenceRow>): Promise<M1DifferenceRow> {
    return this.makeRequest<M1DifferenceRow>(
      `/api/m1-differences/${id}`,
      { method: 'put', data: data as unknown as Record<string, unknown>, extractData: true },
    );
  }
}

export const m1Service = new M1Service();
